import './UtilsLib.js'
import MptcfeWapAd from 'mptcfe-wap-ad'
import loginUtil from 'mptcfe-login-util';

// 设置访问页面的次数，写vt_xxx到cookie中，服务端据此设置轮换逻辑
MptcfeWapAd.setVisitTurn()
const ENV = MptcfeUtils.Utils.getEnvironment(true)
const env = MptcfeUtils.Utils.getEnvironment()

window.MptcfeWapAd = MptcfeWapAd
window.MptcfeLoginUtil = loginUtil
window.$ = $
window.ENV = ENV
window.env = env
window.RUNNINGENV = RUNNINGENV // 挂载RUNNINGENV全局变量，用于Utils库里的环境变量判断，子项目据此进行环境判断